import { Host, h } from "@stencil/core";
export class CardSubtitle {
    constructor() {
        this.inverted = false;
        this.bold = false;
        this.color = '';
    }
    render() {
        return (h(Host, { key: '3926fde414f565f08d192a020366edf1757c6922', class: "bal-card-subtitle" }, h("bal-text", { key: 'a04132e568b034e371f6805e77dbcfe21d9e9489', bold: this.bold, space: "none", color: this.inverted ? 'white' : this.color }, h("slot", { key: '037e237cdaced982f0b3ba0074016aa4777ffbde' }))));
    }
    static get is() { return "bal-card-subtitle"; }
    static get properties() {
        return {
            "inverted": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If `true` the card text color becomes white."
                },
                "getter": false,
                "setter": false,
                "attribute": "inverted",
                "reflect": false,
                "defaultValue": "false"
            },
            "bold": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If `true` the card text color is bold."
                },
                "getter": false,
                "setter": false,
                "attribute": "bold",
                "reflect": false,
                "defaultValue": "false"
            },
            "color": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalHeadingColor",
                    "resolved": "\"\" | \"blue\" | \"danger\" | \"info\" | \"primary\" | \"success\" | \"warning\" | \"white\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If `true` the card text color becomes white."
                },
                "getter": false,
                "setter": false,
                "attribute": "color",
                "reflect": false,
                "defaultValue": "''"
            }
        };
    }
}
